module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-movie-19-years.33b52775.svg";